import { ArrowDownTrayIcon as DownloadIcon } from '@heroicons/react/24/outline';

export const ServiceSheetButton = ({ link }) => {
  return (
    <div className="additional-link-container">
      <div className="additional-link">
        <a className="plain-button" href={link} target="_blank">
          <DownloadIcon className="plain-button-icon" />
          View printed material
        </a>
      </div>
    </div>
  );
};
